export const EXAMPLE_PROMPTS_COPY = {
  title: 'AI Automation Builder Prompts',
  betaBadge: 'Beta',
  description:
    'Example prompts shown to your users when they start a new AI automation. Clicking one fills the message box with the full prompt so they can edit it before sending.',
  emptyTitle: 'No example prompts yet',
  emptyDescription:
    'Without prompts, users see only the message box. Add up to 4 to show what your users can automate.',
  addPrompt: '+ Add prompt',
  limitReached: "You've added the maximum of 4 prompts.",
  promptGroupLabel: (position: number) => `Example prompt ${position}`,
  moveUp: (position: number) => `Move prompt ${position} up`,
  moveDown: (position: number) => `Move prompt ${position} down`,
  remove: 'Remove',
  removeLabel: (position: number) => `Remove prompt ${position}`,
  titleLabel: 'Title',
  titlePlaceholder: 'e.g. Ask for reviews',
  titleHelp: 'Shown on the button. Keep it short so it fits on one line.',
  promptLabel: 'Prompt',
  promptPlaceholder:
    'The full message that goes into the message box, e.g. Ask for a review the day after a pet checks out',
  missingTitleAndPrompt: 'Add a title and a prompt, or remove this row.',
  missingTitle: 'Add a title.',
  missingPrompt: 'Add a prompt.',
  previewLabel: 'Preview',
  previewComposerPlaceholder: "e.g. Text clients who haven't booked in 60 days",
} as const;

export const TITLE_WARNING_LENGTH = 50;
export const PROMPT_WARNING_LENGTH = 450;
